import { makeAutoObservable } from 'mobx'
import { toJS } from 'mobx'

import { MainPageExcursions } from 'shared/api/excursions/main-page'

import { PopularDirectionExcursions } from './module'

class PopularDirectionStore {
  popularDirections: PopularDirectionExcursions[] | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async fetchPopularDirections() {
    try {
      const { data: popularExcursions } =
        await MainPageExcursions.getPromotions(true)

      this.popularDirections = popularExcursions.data
    } catch (error) {
      console.error('Failed to fetch popular directions:', error)
    }
  }

  setPopularDirections(data: PopularDirectionExcursions[] | null) {
    this.popularDirections = data
  }

  getPopularDirections() {
    return toJS(this.popularDirections)
  }
}

export const popularDirectionExcursionsStore = new PopularDirectionStore()
